"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ReasonForDonatingFields = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _lodash = _interopRequireDefault(require("lodash"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reduxForm = require("redux-form");

var _fields = require("../../fields");

var _reasonForDonatingConfig = require("./reasonForDonatingConfig");

var _selectConfigWithAdditionalItems = _interopRequireDefault(require("../../utils/selectConfigWithAdditionalItems"));

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var ReasonForDonatingDefinition = _flowRuntime["default"].tdz(function () {
  return _reasonForDonatingConfig.ReasonForDonatingDefinition;
});

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("queryParams", _flowRuntime["default"].object()), _flowRuntime["default"].property("reasonOption", _flowRuntime["default"].string()), _flowRuntime["default"].property("resetFields", _flowRuntime["default"]["function"](_flowRuntime["default"]["return"](_flowRuntime["default"]["void"]()))), _flowRuntime["default"].property("setReason", _flowRuntime["default"]["function"](_flowRuntime["default"].param("_arg0", _flowRuntime["default"].string()), _flowRuntime["default"]["return"](_flowRuntime["default"]["void"]()))), _flowRuntime["default"].property("reasonForDonating", _flowRuntime["default"].ref(ReasonForDonatingDefinition))));

var ReasonForDonatingFields = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(ReasonForDonatingFields, _React$Component);

  var _super = (0, _createSuper2["default"])(ReasonForDonatingFields);

  function ReasonForDonatingFields() {
    var _this;

    (0, _classCallCheck2["default"])(this, ReasonForDonatingFields);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.handleChange = function () {
      var resetFields = _this.props.resetFields;
      resetFields();
    };

    return _this;
  }

  (0, _createClass2["default"])(ReasonForDonatingFields, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          queryParams = _this$props.queryParams,
          setReason = _this$props.setReason;

      if (queryParams && queryParams.ref) {
        var refString = queryParams.ref;
        setReason(refString);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          reasonForDonating = _this$props2.reasonForDonating,
          queryParams = _this$props2.queryParams,
          reasonOption = _this$props2.reasonOption;

      var reasonConfig = _reasonForDonatingConfig.reasonConfigs.find(function (rc) {
        return rc.selectItem.value === reasonOption;
      });

      var reasonNotesTextfield = _lodash["default"].get(reasonConfig, 'notesTextfield');

      var reasonForDonatingItems = _lodash["default"].map(_reasonForDonatingConfig.reasonConfigs, function (x) {
        return x.selectItem;
      });

      return queryParams && !queryParams.ref ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_fields.Select, {
        key: _reasonForDonatingConfig.reasonForDonatingSelect.key,
        id: _reasonForDonatingConfig.reasonForDonatingSelect.key,
        select: (0, _selectConfigWithAdditionalItems["default"])(_reasonForDonatingConfig.reasonForDonatingSelect, reasonForDonatingItems, reasonForDonating.items),
        onChange: this.handleChange
      }), reasonNotesTextfield && reasonNotesTextfield.label !== '' && /*#__PURE__*/_react["default"].createElement(_fields.Textfield, {
        key: reasonNotesTextfield.key,
        id: reasonNotesTextfield.key,
        textfield: reasonNotesTextfield
      })) : null;
    }
  }]);
  return ReasonForDonatingFields;
}(_react["default"].Component);

exports.ReasonForDonatingFields = ReasonForDonatingFields;
var selector = (0, _reduxForm.formValueSelector)('form');

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var componentKey = ownProps.componentKey;
  return {
    reasonOption: selector(state, "".concat(componentKey, ".reason"))
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var componentKey = ownProps.componentKey;
  var reasonPath = "".concat(componentKey, ".reason");
  var notesPath = "".concat(componentKey, ".notes");
  var fields = [reasonPath, notesPath];
  return {
    setReason: function setReason(refString) {
      return dispatch((0, _reduxForm.change)('form', reasonPath, refString));
    },
    resetFields: function resetFields() {
      Promise.all([dispatch((0, _reduxForm.change)('form', reasonPath, '')), dispatch((0, _reduxForm.change)('form', notesPath, '')), dispatch(_reduxForm.untouch.apply(void 0, ['form'].concat(fields)))]);
    }
  };
}; // $FlowFixMe WEB-352


var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ReasonForDonatingFields);

exports["default"] = _default;